import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: '/umbraco/api/OnTheCornerApi',
    }),
    tagTypes: ['Results'],
    endpoints(builder) {
        return {
            getLimitedArticles: builder.query({
                query: (args) => {
                    // Destructuring Object
                    let { page, filter, limit, landingPage, sortBy } = args;
                    let filtersString = filter.length > 1 ? filter.join(',') : filter;
                    return {
                        url: `/GetOnTheCornerItems?offset=${page * limit}&limit=${limit}&categories=${filtersString}&isLandingPage=${landingPage}&sortType=${sortBy}`
                    };
                },
               
                // Only have one cache entry because the arg always maps to one string
                serializeQueryArgs: ({ endpointName }) => {
                    return endpointName;
                },
                // Always merge incoming data to the cache entry
                  merge: (currentCache, newItems) => {
                      currentCache.items.push(...newItems.items);
                },
                // Refetch when the page arg changes
               forceRefetch({ currentArg, previousArg }) {
                    return currentArg !== previousArg;
               },
            }),
        };
    },
});

export const { useGetLimitedArticlesQuery } = apiSlice; 